<ng-container *transloco="let t;">

  <app-loader [loading]="loading"></app-loader>

  <form (submit)="onSubmit()" novalidate *ngIf="loading !== true">

    <div class="p-grid">
        <div class="p-col-6">
            <h2>{{ t('common.labels.basedata') }}</h2>
        </div>
        <div class="p-col-6 p-text-right">
          <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
        </div>
    </div>

    <div class="p-grid p-fluid">

        <div class="p-col-12">
          <app-form-control [cid]="'active'" [control]="form.get('active')" [type]="'checkbox'" [label]="t('common.labels.active')"></app-form-control>
        </div>

        <div class="p-col-12 p-md-6">
          <app-form-control [cid]="'name'" [control]="form.get('name')" [type]="'input'" [label]="t('common.labels.name')"></app-form-control>
          <app-form-control [cid]="'type'" [control]="form.get('type')" [type]="'select'" [options]="types" [label]="t('common.labels.type')"></app-form-control>
          <app-form-control [cid]="'capacity'" [control]="form.get('capacity')" [type]="'input'" [label]="t('common.labels.capacity')"></app-form-control>
        </div>
        <div class="p-col-12 p-md-6">
          <app-form-control [cid]="'location'" [control]="form.get('location')" [type]="'select'" [options]="locations" optionLabel="name" [label]="t('common.labels.location')"></app-form-control>
          <app-form-control [cid]="'zip'" [control]="form.get('zip')" [type]="'input'" [label]="t('common.labels.zip')"></app-form-control>
          <app-form-control [cid]="'street'" [control]="form.get('street')" [type]="'input'" [label]="t('common.labels.street')"></app-form-control>
          <app-form-control [cid]="'addition'" [control]="form.get('addition')" [type]="'input'" [label]="t('common.labels.addition')"></app-form-control>
        </div>

        <div class="p-col-12">
            <h2>{{ t('common.labels.contacts') }}</h2>
        </div>

        <div class="p-col-12 p-md-6">
          <app-form-control [cid]="'mail_registration'" [control]="form.get('mail_registration')" [type]="'input'" [label]="t('rooms.labels.mail_registration')"></app-form-control>
        </div>
        <div class="p-col-12 p-md-6">
          <app-form-control [cid]="'mail_catering'" [control]="form.get('mail_catering')" [type]="'input'" [label]="t('rooms.labels.mail_catering')"></app-form-control>
        </div>

    </div>

  </form>
</ng-container>
